<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

defineProps({
  items: {
    type: Array,
    required: true,
  },
});

const dropdownOpen = ref(false);
const dropdownRef = ref(null);
const buttonRef = ref(null);

const toggleDropdown = (event) => {
  event.stopPropagation();
  dropdownOpen.value = !dropdownOpen.value;
};

const handleClickOutside = (event) => {
  if (
    !dropdownRef.value?.contains(event.target) &&
    !buttonRef.value?.contains(event.target)
  ) {
    dropdownOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

const handleItemClick = (item) => {
  dropdownOpen.value = false;
  item.action && item.action();
};
</script>

<template>
  <div class="relative inline-block text-left">
    <!-- Button -->
    <button
      ref="buttonRef"
      @click="toggleDropdown"
      type="button"
      class="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
      aria-expanded="dropdownOpen"
      aria-haspopup="true"
    >
      <slot name="buttonText"></slot>
    </button>

    <!-- Dropdown menu with transition -->
    <Transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="dropdownOpen"
        ref="dropdownRef"
        class="absolute right-0 z-10 mt-2 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 overflow-hidden min-w-max"
      >
        <div class="py-0">
          <template v-for="(item, index) in items" :key="index">
            <a
              v-if="item.type === 'link'"
              :href="item.href"
              @click.prevent="handleItemClick(item)"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 cursor-pointer whitespace-nowrap"
            >
              {{ item.label }}
            </a>
          </template>
        </div>
      </div>
    </Transition>
  </div>
</template>
